import { LandingWineCampaignApiModel } from "./LandingWineCampaignApiModel";

export class LandingWinesManualSendApiModel {
	campaigns: Array<LandingWineCampaignApiModel>;
	testRun: boolean;
	testRunOverrideEmailAddress: string;
}
